export const SubjectKind = {
  AMBIGUITY_STATEMENT: 'ambiguity_statement',
  STANDARD_DEVIATION_STATEMENT: 'standard_deviation_statement',
  CLAUSE_SCANNER_CLAUSE: 'clause_scanner_clause',
  LEGAL_DEVIATION_CLUSTER: 'legal_deviation_cluster',
  LEGAL_DEVIATION_STATEMENT: 'legal_deviation_statement',
  LEGAL_DEVIATION_CLAUSE_SCANNER_RESULT: 'legal_deviation_clause_scanner_result',
  CUSTOM_TOPIC_STATEMENT: 'custom_topic_statement',
  CUSTOM_TOPIC_QUERY: 'custom_topic_query',
  EVALUATION_CONFLICT_FINDING: 'evaluation_conflict_finding',
  STRENGTHS_WEAKNESSES_STATEMENT: 'strengths_weaknesses_statement',
  CHANGE_ASSESSMENT: 'change_assessment',
  SCOPE_PACK_RISK: 'scope_pack_risk',
  SCOPE_ITEM: 'scope_item',
  ARTIFACT_SHEET_ROW: 'artifact_sheet_row',
  BID_DRAFT_DOCUMENT: 'bid_draft_document',
  BID_SUBMISSION_COVERAGE: 'saved_source:1700',
  BID_COMPARISON: 'saved_source:1300',
  WORK_PACKAGE_COLUMN: 'saved_source:102',
  BID_CV_STATEMENT: 'saved_source:1400',
  BID_RESERVATION: 'saved_source:1500',
  PROCUREMENT_COVERAGE: 'saved_source:2100',
  CHECKLIST_ITEM: 'saved_source:2200',
  BID_DRAFTING: 'bid_drafting',
  BID_CV_POSITION: 'bid_cv_position',
  STANDARD_DEVIATION_GROUP: 'standard_deviation_group',
  WORK_PACKAGE: 'work_package',
  WORK_PACKAGE_DISCIPLINE: 'work_package_discipline',
  BID_METHODOLOGY: 'bid_methodology',
  TENDER_CRITERION: 'tender_criterion',
  TENDER_FEEDBACK: 'tender_feedback',
  KG_WORK_PACKAGE: 'kg_work_package',
  KG_WORK_PACKAGE_SCOPE_ITEM: 'kg_work_package_scope_item',
  KG_WORK_PACKAGE_COMPLIANCE_ITEM: 'kg_work_package_compliance_item',
  KG_WORK_PACKAGE_LEVELING_CELL: 'kg_work_package_leveling_cell',
  KG_WORK_PACKAGE_QUERY_CELL: 'kg_work_package_query_cell',
  KG_WORK_PACKAGE_BASELINE_GROUP: 'kg_work_package_baseline_group',
  CHAT: 'chat',
  CHAT_MESSAGE: 'chat_message',
  CHECKLIST_RUN: 'checklist_run',
  TASK: 'task',
} as const;

export type SubjectKind = (typeof SubjectKind)[keyof typeof SubjectKind];
